/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    google: {
        families: ['Maven+Pro:400,500,600,700&display=swap']
    }
});


// Variabili globali
//--------------------------------------------------------------------//

window.__GLOBAL =
{
    resolutions:
    {
        mobile:             0,
        tabletPortrait:   768,
        tabletLandscape: 1024,
        desktop:         1025,
        headerExpanded:  1025
    }
};

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
// import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

//import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

//initSvgImage();

smoothScroll();

//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//

import { animation } from '../components/animation/animation';
import header from 'components/header/header';
import footer from 'components/footer/footer';


//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//
addEventListener('DOMContentLoaded', (evt) =>
{
    header();
    animation();
});

//--------------------------------------------------------------------//